import { Typography } from 'fitify-ui-landing/src/components/Typography/Typography'
import type { ButtonHTMLAttributes, PropsWithChildren, ReactNode } from 'react'

import { StyledButton } from './Button.Styled'

type Props = PropsWithChildren<{
  className?: string
  icon?: ReactNode
  isActive?: boolean
  variant?: 'button' | 'circle'
}> &
  ButtonHTMLAttributes<HTMLButtonElement>

export const Button = ({
  children,
  className,
  icon,
  isActive,
  variant = 'button',
  ...htmlProps
}: Props) => {
  return (
    <StyledButton
      className={className}
      $isActive={isActive}
      $variant={variant}
      {...htmlProps}
    >
      {icon}
      <Typography $variant="Special/Label 14">{children}</Typography>
    </StyledButton>
  )
}
